PageInits = {
  //=== Collection Page ===================================================
  collection: function(a){
    var top = 0;
    var main = jQuery(a);
    var randomClass = ( 'eH' + Math.random() ).replace('.','');
    // console.log('A random class: ' + randomClass); // ?
    main.each( function() {

      var distanceFromTop = jQuery(this).offset().top;
      // console.log('This is ' + distanceFromTop + ' from the top.');

      if ( distanceFromTop > top ) {
        jQuery('.' + randomClass).removeClass(randomClass);
        top = distanceFromTop;
        // console.log('"top" is ' + top + 'px away');
      }

      jQuery(this).addClass(randomClass);

      jQuery(this).css('min-height','auto');

      var newHeight = (Math.max.apply(null, jQuery('.' + randomClass).map( function() {
        return jQuery(this).outerHeight();
      }).get()));

      jQuery('.' + randomClass).css('min-height',newHeight);

    }).removeClass(randomClass);

  }
}
jQuery(document).ready(function() {
  if(jQuery(".detail-col-wrp h4").length > 0)PageInits.collection(".detail-col-wrp h4");
  jQuery(window).scroll(function() { if(jQuery(".detail-col-wrp h4").length > 0)PageInits.collection(".detail-col-wrp h4") });
  jQuery(window).resize(function() { if(jQuery(".detail-col-wrp h4").length > 0)PageInits.collection(".detail-col-wrp h4") });
});

//# sourceMappingURL=/s/files/1/0540/3475/9855/t/19/assets/custom.js.map?v=1643098907


/*Collection Color Swatches*/
selector = {
  labelSelector : document.querySelectorAll(`.color-swatch-label`)  
}


swatchesInit = {
  init:function(){
    selector.labelSelector.forEach(element => this.swatchClickListener(element));
  },
  swatchClickListener:function(e){
    e.addEventListener('click', function(e){
      let $this = e.currentTarget,   
          variantId = $this.dataset.variantId,
          productId = $this.dataset.productId,
          productGrid = $this.closest(`.product_item-grid`);
      productGrid.querySelector(`.color-swatch-label.isActive`).classList.remove(`isActive`);      
      $this.classList.add(`isActive`);
      if(document.querySelector(`.variant__content--${variantId}`)){      
        console.log("ifff")
        var imgHtml = document.querySelector(`.variant__content--${variantId}`).innerHTML;
        	productGrid.querySelector(`.image__container.product__imageContainer`).innerHTML = imgHtml;
      }else{
        console.log("else")
        productGrid.querySelector(`.image__container.product__imageContainer`).innerHTML = productGrid.querySelector('.variant__content--product-featured_image').innerHTML;
      }
    });
  }
}
swatchesInit.init();

window.addEventListener('load', () => {
  if ( Shopify.routes.root_url !== '/' ) {
    const hideInterval = setInterval(() => {
      if ( document.querySelector('.mlveda-div') ) {
        clearInterval(hideInterval);
        document.querySelector('.mlveda-div').setAttribute('style', 'display: none !important;');
      }
    }, 50);
  }
});


/*mobile filter JS*/
(function() {
  var sidebar         = document.getElementById('sidebar');
  var sidebarOverlay  = document.getElementsByClassName('sidebar-overlay')[0];
  var container       = document.getElementsByClassName('container')[0];
  var sidebarBtnClose = document.getElementById('sidebarBtnClose');
  var sidebarBtnOpen  = document.getElementById('sidebarBtnOpen');


  if(document.querySelectorAll(`#sidebarBtnOpen`).length){
    document.querySelector(`#sidebarBtnOpen`).addEventListener('click', event => {
      document.getElementsByTagName( 'html' )[0].classList.add("filter-mobile-open");
      sidebarOverlay.style.left = '0';
      sidebar.style.left = '0';
    });
  }

  if(document.querySelectorAll(`#sidebarBtnClose`).length){
    document.querySelector(`#sidebarBtnClose`).addEventListener('click', event => {
      document.getElementsByTagName( 'html' )[0].classList.remove("filter-mobile-open");
      event.cancelBubble = true;
      sidebarOverlay.style.left = '-100%';
      sidebar.style.left = '-103%';
    });
  }

  if(document.querySelectorAll(`.sidebar-overlay`).length){
    document.querySelector(`.sidebar-overlay`).addEventListener('click', event => {
      document.getElementsByTagName( 'html' )[0].classList.remove("filter-mobile-open");
      event.cancelBubble = true;
      sidebarOverlay.style.left = '-100%';
      sidebar.style.left = '-103%';
    });
   
  }

  //   var openSidebar = function() {
  //     document.getElementsByTagName( 'html' )[0].classList.add("filter-mobile-open");
  //     sidebarOverlay.style.left = '0';
  //     sidebar.style.left = '0';
  //   }
  //   var closeSidebar = function(e) {
  //     document.getElementsByTagName( 'html' )[0].classList.remove("filter-mobile-open");
  //     e.cancelBubble = true;
  //     sidebarOverlay.style.left = '-100%';
  //     sidebar.style.left = '-103%';
  //   }

  //   if(jQuery('sidebar-overlay').length) sidebarOverlay.addEventListener('click', closeSidebar);
  //   if(jQuery('sidebarBtnClose').length) sidebarBtnClose.addEventListener('click', closeSidebar);
  //   if(jQuery('sidebarBtnOpen').length) sidebarBtnOpen.addEventListener('click', openSidebar);

})()



jQuery(window).scroll(function(){
    var shopifyProductForm = jQuery(".shopify-product-form");
    if (shopifyProductForm.length) {
      if(jQuery(window).scrollTop() >= jQuery(".shopify-product-form").offset().top + jQuery(".product-form-container").height())
        jQuery('.sticky_product__cover').removeClass('hide');  
      else
        jQuery('.sticky_product__cover').addClass('hide');      
    }  
});

jQuery(document).on('click', '#cart_product', function (e) {
  jQuery("[data-add-to-cart-trigger]").click();
});


  var elem = document.querySelector(".review_slider");
    if(elem){
      var flkty = new Flickity(elem, {          
          cellAlign: "center",
          contain: false,
        freeScroll: true,
        autoPlay: true,
          wrapAround: true
          
      });      
      // Flickity - select cell on staticClick, vanilla JS
      flkty.on("staticClick", function(event, pointer, cellElement, cellIndex) {
        if (typeof cellIndex == "number") {
          flkty.selectCell(cellIndex);
        }
      })};


setTimeout(function(){      

  var viewport = jQuery('meta[name="viewport"]');

  if (screen.width <= 560) {
      viewport.attr("content", "width=device-width, initial-scale=1"); 
  } else {
      viewport.attr("content", "width=device-width, initial-scale=1"); 
  }

}, 2000);


const mobile_slider = document.querySelector('.__mobile_slider');
if(window.innerWidth < 899){
  if(mobile_slider){
    mobile_slider.classList.add('enable_slider_mobile');
  }  
}
  var elem = document.querySelector('.enable_slider_mobile');
  if(elem){
    var flkty = new Flickity( elem, {
      // options
      cellAlign: 'left',
      contain: true,
      prevNextButtons: true,
      pageDots: true    
    });
  }  

document.addEventListener('DOMContentLoaded', function () {
    const filterTopCover = document.querySelector('.filter_top__cover .btn-filter');
    const dropdown = document.querySelector('.sidebar-section');

    if(filterTopCover && dropdown){
      filterTopCover.addEventListener('mouseenter', function (e) {
          dropdown.classList.add('active');
      });
      filterTopCover.addEventListener('mouseleave', function () {
          dropdown.classList.remove('active');
      });
      filterTopCover.addEventListener('click', event => {
         dropdown.classList.toggle('active');
      });
    }
})


